/**
 * Application Configuration
 *
 * Google Drive API is used to fetch property data from public folders.
 * No Maps API key needed - map uses free OpenStreetMap via Cloudflare proxy.
 *
 * To set up Google Drive:
 * 1. Create a Google Cloud Project → Enable Google Drive API
 * 2. Create an API Key
 * 3. Share your root Drive folder as "Anyone with the link can view"
 * 4. Set REACT_APP_GOOGLE_API_KEY and REACT_APP_DRIVE_FOLDER_ID
 */

const config = {
  // Google Maps API
  googleMaps: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  },

  // Google Drive API
  googleDrive: {
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
    rootFolderId: process.env.REACT_APP_DRIVE_FOLDER_ID || '',
    apiBaseUrl: 'https://www.googleapis.com/drive/v3',
  },

  // Seed key for XOR decrypting property.txt data CLIENT-SIDE
  // The property.txt file is stored encrypted (base64 + XOR cipher) using this key.
  // When the browser downloads property.txt, it decrypts it in the app to display data.
  seedKey: process.env.REACT_APP_SEED_KEY || '',

  // Feature flags
  features: {
    useGoogleDrive: true,
    cacheDurationMs: 5 * 60 * 1000, // 5 minutes cache
  },
};

export default config;